module.exports = __webpack_public_path__ + "img/parcela1.229a6b69.png";